import { FC, useEffect, useRef, useState } from "react";
import styles from "./trading.module.scss";
import useRWD from "../../componsnts/hooks/useRWD";
import { DeviceType } from "../../componsnts/hooks/useRWD";
import Breadcrumbs from "../../componsnts/common/breadcrumbs/breadcrumbs";
import ScrollToTop from "../../componsnts/common/scroll-to-top/scroll-to-top";
import SectionTitle from "../../componsnts/common/sectionTitle/sectionTitle";

const Trading: FC = () => {
  const [containerClass, setContainerClass] = useState("container");

  const handleResize = () => {
    if (window.innerWidth < 992) {
      setContainerClass("container-fluid");
    } else {
    }

    if (window.innerWidth < 768) {
      setContainerClass("container");
    } else {
    }

    if (window.innerWidth > 992) {
      setContainerClass("container");
    } else {
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles["trading_container"]}>
      <div className="banner_sec">
        <div className="banner_title_box ">
          <div className="d-flex justify-content-center">
            <SectionTitle
              title="多元化交易"
              titleColor="#fff"
              subTitle="DIVERSE"
              subTitleColor="rgba(0, 149, 217, 0.50)"
              backgroundColor="#0077AE"
            />
          </div>
        </div>

        <div className="banner_text_box">
          <div
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-once="false"
            className="test"
          >
            <div className="banner_title">綠電交易介紹</div>
            <div className="banner_subTitle">大創解決方案介紹</div>
            <div className="banner_text_container">
              <div className="banner_text_1">
                企業商辦大樓或是全天性運作廠房；我們都能提供相應的解決方案！
              </div>
              <br></br>
              <div className="banner_text_2">
                針對不同的用電區間，會有不同的費率；再者，白天用電與全天性用電勢必存在差異！
                我們針對不同用電戶需求，協助用戶完成購電計畫、並達成企業環境永續目標！
              </div>
            </div>
          </div>

          <div className="banner_img_container">
            <div className="img_box">
              <img
                className="banner_img down"
                src="/assets/images/trading/compressed/banner_left_img.png"
                alt="building"
              />
              <img
                className="banner_img up"
                src="/assets/images/trading/compressed/banner_right_img.png"
                alt="building"
              />
            </div>
          </div>
        </div>
      </div>

      <section className="section_2">
        <div
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-once="false"
          className="section_box"
        >
          <div className={containerClass}>
            <div className="row">
              <div className="col-md-6 col-sm-12 content_box  order-last order-md-first">
                <div className="sec_title_box">
                  <div className="sec_bg_title">TEMPLATE</div>
                  <div className="sec_title">公開化的模板</div>
                  <div className="sec_subTitle">自由挑選綠電合作夥伴</div>
                </div>
                <div className="sec_text">
                提供完善的平台供用戶審查後自由刊登；剩餘可轉供容量大創亦會完整雲端紀錄，
                以避免超買或超賣的情形發生。同時將發電量能與效益一併在公開平台上分析檢視！
                我們讓中小型企業能夠透過公開化的資訊，自我分析評估用電需求；並開始擬訂購電計畫！
                </div>
              </div>
              <div className="col-md-6 col-sm-12 img_box ">
                <img
                  className="img"
                  src="/assets/images/trading/compressed/sec_1.png"
                  alt="sec2-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section_3">
        <div
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-once="false"
          className="section_box"
        >
          <div className={containerClass}>
            <div className="row">
              <div className="col-md-6 col-sm-12 img_box">
                <img
                  className="img"
                  src="/assets/images/trading/compressed/sec_2.png"
                  alt="sec2-img"
                />
              </div>

              <div className="col-md-6 col-sm-12 content_box">
                <div className="sec_title_box">
                  <div className="sec_bg_title">FOLLOW UP</div>
                  <div className="sec_title">專案進度追蹤</div>
                  <div className="sec_subTitle">讓用戶了解辦理進度</div>
                </div>
                <div className="sec_text">
                在平台可以時刻檢視查詢各購電專案的辦理進度為何；
                用戶無須煩惱或時常需要電話郵件聯繫以追蹤進度，平台會直接紀錄當前文件辦理進度到哪
                ，並以百分比的方式作呈現；如有碰上問題亦會立即專員反饋給用戶，確保用戶取得並使用綠電。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section_4">
        <div
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-once="false"
          className="section_box"
        >
          <div className={containerClass}>
            <div className="row">
              <div className="col-md-6 col-sm-12 content_box  order-last order-md-first">
                <div className="sec_title_box">
                  <div className="sec_bg_title">SOLUTION</div>
                  <div className="sec_title">解決方案</div>
                  <div className="sec_subTitle">與我們討論並成立專案</div>
                </div>
                <div className="sec_text">
                  提供媒合結果供用戶參考，同時協助計算大略的綠電使用效益（根據天氣等因素在實際使用上會有些許落差）；
                  用戶可以透過專案去了解到根據所提出的需求，大創協助配對並提供了哪些廠商一同合作，
                  了解到自己的每一份綠電從何而來，占了多少總體經濟價值！
                </div>
              </div>
              <div className="col-md-6 col-sm-12 img_box ">
                <img
                  className="img"
                  src="/assets/images/trading/compressed/sec_3.png"
                  alt="sec3-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop></ScrollToTop>
    </div>
  );
};
export default Trading;
